import styled from 'styled-components';
import { getTextPresetCss } from '@optimus-web/common';
import { Component, Decision, getComponentVariableToken, TEXT_PRESET_KEY } from '@optimus-web/local-tokens';

const getInputAffixToken = getComponentVariableToken(Component.InputAffix, 'variant');

export const Affix = styled.div`
    ${getTextPresetCss(TEXT_PRESET_KEY['100r'])}
    color: ${getInputAffixToken(Decision.Color)};
`;
